import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

export const AddZoneCategoryDialog = ({ openModal, setOpenModal, updatedZoneCategories, addZoneCategory }) => {
    const [newCategoryName, setNewCategoryName] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const isExisting = updatedZoneCategories.some(
            (option) => newCategoryName?.trim() === option['display_name']?.trim()
        );
        if (newCategoryName?.length > 150) {
            setError('Must be 150 characters or less.');
        } else if (isExisting) {
            setError('Zone Category must be unique.');
        } else {
            setError(null);
        }
    }, [newCategoryName, updatedZoneCategories]);

    const handleDialogKeyUp = (event) => {
        if (event.key === 'Enter') {
            handleSubmit();
        }
    };

    const handleSubmit = () => {
        if (!error) {
            setNewCategoryName(null);
            setError(null);
            addZoneCategory(newCategoryName);
        }
    };

    return (
        <Dialog open={openModal}>
            <DialogTitle>Add a new Zone Category</DialogTitle>
            <DialogContent sx={{ width: '400px' }}>
                <TextField
                    fullWidth
                    autoFocus
                    margin="dense"
                    id="name"
                    onChange={(event) => {
                        setNewCategoryName(event.target.value);
                    }}
                    label="Zone Category"
                    type="text"
                    variant="outlined"
                    error={!!error}
                    helperText={error}
                    onKeyUp={(event) => {
                        handleDialogKeyUp(event);
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                        setOpenModal(false);
                    }}
                >
                    Cancel
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    color="primary"
                    disabled={!newCategoryName}
                    onClick={() => {
                        handleSubmit();
                    }}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};
